import { render, staticRenderFns } from "./EmailDynamic.vue?vue&type=template&id=ce4dd540&scoped=true"
import script from "./EmailDynamic.vue?vue&type=script&lang=ts"
export * from "./EmailDynamic.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4dd540",
  null
  
)

export default component.exports